"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumnItem;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _AbstractElement = _interopRequireDefault(require("../elements/AbstractElement"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var HORIZONTAL_ALIGNMENT_TYPES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
var VERTICAL_ALIGNMENT_TYPES = {
  top: 'private-multicolumn--align-top',
  middle: 'private-multicolumn--align-middle',
  bottom: 'private-multicolumn--align-bottom'
};

var getTitleText = function getTitleText(titleText, titleSize) {
  return _react.default.createElement(_AbstractElement.default, {
    className: "private-multicolumn__item__title",
    tagName: titleSize
  }, titleText);
};

function UIMultiColumnItem(props) {
  var children = props.children,
      className = props.className,
      horizontalAlign = props.horizontalAlign,
      titleSize = props.titleSize,
      titleText = props.titleText,
      verticalAlign = props.verticalAlign,
      width = props.width,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "horizontalAlign", "titleSize", "titleText", "verticalAlign", "width"]);
  var renderedTitle = titleText ? getTitleText(titleText, titleSize) : null;
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classNames.default)('private-multicolumn__item', 'has--vertical-spacing', HORIZONTAL_ALIGNMENT_TYPES[horizontalAlign], VERTICAL_ALIGNMENT_TYPES[verticalAlign], className),
    style: {
      width: width
    }
  }), renderedTitle, children);
}

UIMultiColumnItem.displayName = 'UIMultiColumnItem';
UIMultiColumnItem.propTypes = {
  children: _react.PropTypes.node,
  horizontalAlign: _react.PropTypes.oneOf(Object.keys(HORIZONTAL_ALIGNMENT_TYPES)),
  titleSize: (0, _deprecated.default)(_react.PropTypes.string, {
    message: 'UIMultiColumnItem: The `titleSize` prop is deprecated. If you need a custom-styled title, you can render it directly in `children`.',
    key: "UIMultiColumnItem: titleSize"
  }, 'h3'),
  titleText: _react.PropTypes.node,
  verticalAlign: _react.PropTypes.oneOf(Object.keys(VERTICAL_ALIGNMENT_TYPES)),
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};
UIMultiColumnItem.defaultProps = {
  titleSize: 'h3',
  verticalAlign: 'middle'
};
module.exports = exports.default;